// extracted by mini-css-extract-plugin
export default {"main-header":"Header_main-header__SXPyA","Headercontainer1":"Header_Headercontainer1__+cftt","headerimage":"Header_headerimage__yuRVz","headerbutton":"Header_headerbutton__o+916"};